import {
  THEME_BRAND_2026,
  THEME_DEFAULT,
  transparentBackground,
  useBodyStyles,
} from '@calendly/ui/body-styles'

import { useProductRefreshUiTheme } from './useProductRefreshUiTheme'

export const BookingBodyStylesManager = () => {
  const isProductRefreshUiTheme = useProductRefreshUiTheme()

  useBodyStyles({
    background: transparentBackground,
    theme: isProductRefreshUiTheme ? THEME_BRAND_2026 : THEME_DEFAULT,
  })

  return null
}
